import React from 'react';
import { PropertyCard } from './PropertyCard';
import { ArrowRight } from 'lucide-react';
import { PROPERTIES } from '../data/properties';
export function PropertyGrid() {
  return <section className="py-24 px-6 md:px-12 max-w-7xl mx-auto" data-id="element-93">
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6" data-id="element-94">
        <div data-id="element-95">
          <h2 className="text-3xl md:text-4xl font-light text-charcoal-900 mb-4" data-id="element-96">
            Curated Collection
          </h2>
          <p className="text-charcoal-500 max-w-xl text-lg" data-id="element-97">
            Explore our hand-picked selection of the world's most extraordinary
            properties, updated daily.
          </p>
        </div>
        <button className="flex items-center gap-2 text-charcoal-900 font-medium hover:gap-4 transition-all" data-id="element-98">
          View All Properties <ArrowRight size={20} data-id="element-99" />
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16" data-id="element-100">
        {PROPERTIES.map(property => <PropertyCard key={property.id} {...property} data-id="element-101" />)}
      </div>
    </section>;
}